import { render, staticRenderFns } from "./UnidadeAdministrativa.vue?vue&type=template&id=4fb0b597&scoped=true"
import script from "./UnidadeAdministrativa.vue?vue&type=script&lang=js"
export * from "./UnidadeAdministrativa.vue?vue&type=script&lang=js"
import style0 from "./UnidadeAdministrativa.vue?vue&type=style&index=0&id=4fb0b597&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb0b597",
  null
  
)

export default component.exports